export default {
    namespaced: true,
    state: {
        stopWords: [],
    },
    getters: {
        STOP_WORDS: state => {
            return state.stopWords;
        },
    },
    mutations: {
        STOP_WORDS: (state, payload) => {
            return state.stopWords = payload;
        },
    },
    actions: {
        GET_DATA: async ({state}, payload) => {
            payload.th.showOverlay++;
            await payload.th.$store.dispatch('SEND_GET', {
                url: '/suppliers/stop-words',
                th: payload.th,
                showSuccessMessage: false,
                getSuccessResponse: (responseData) => {
                    state.stopWords = responseData.stopWords
                    payload.th.prepareValue()
                },
                getResponse: () => {
                    payload.th.showOverlay--;
                },
            });
        },
        SAVE: async ({state}, payload) => {
            payload.th.showOverlay++;
            await payload.th.$store.dispatch('SEND_POST', {
                url: '/suppliers/stop-words',
                parameter: state.stopWords,
                th: payload.th,
                showSuccessMessage: false,
                getSuccessResponse: (responseData) => {
                    state.stopWords = responseData.stopWords
                    payload.th.prepareValue()
                },
                getResponse: () => {
                    payload.th.showOverlay--;
                }
            });
        },
    }
}